<template>
  <card-wrapper
    :max-width="history ? null : 'min(90vw, 400px)'"
    :isHeightDisabled="true"
    class="punchcard-detail-card"
    :class="{ 'history-card-padding': history }"
  >
    <template v-slot:textBody>
      <v-row class="header-row align-center no-gutters">
        <v-col cols="12" class="d-flex align-center">
          <div class="detail-header">
            {{ history ? translatedName(punchCard) : translatedName(currentPunchCardData) }}
          </div>
        </v-col>
      </v-row>

      <v-row
        class="description-row no-gutters"
        :style="{ cursor: 'default' }"
      >
        <v-col cols="12">
          <ul class="reward-description-list" ref="descriptionList">
            <li class="description-collapsed-ellipsis">
                {{ descriptionRows[0] }}
            </li>
            <li v-if="hasTargets" class="description-collapsed-ellipsis">
               Valid for select items
            </li>
            <!-- <template v-if="!showAllDetails"> -->
              <!-- <li class="description-collapsed-ellipsis">
                {{ descriptionRows[0] }}
              </li>
              <li
                v-if="descriptionRows.length > 1"
                class="description-collapsed-ellipsis"
              >
                {{ descriptionRows[1] }}
              </li> -->
            <!-- </template> -->
            <!-- <template v-else>
              <li
                v-for="(row, idx) in descriptionRows"
                :key="idx"
                class="description-expanded"
              >
                {{ row }}
              </li>
            </template> -->
          </ul>
          <div v-if="!history && (showMoreDetailsLink || showAllDetails)" class="more-detail-link" @click="openConfig">
            More Details
          </div>
        </v-col>
      </v-row>
    </template>

    <template v-slot:description>
      <template v-if="history">
        <v-row style="display:flex" class="quantity-selector-row align-center no-gutters">
          <v-col cols="auto" class="flex-grow-0 pr-0">
            <div class="static-quantity-display">{{ punchCard.qty }}</div>
          </v-col>
          <v-col class="pl-2 d-flex align-center">
            <span class="redeemed-item-text">
              Free {{ punchCard.qty === 1 ? (currentPunchCardData.unitString || 'item').toLowerCase() : (currentPunchCardData.unitPluralString || currentPunchCardData.unitString || 'items').toLowerCase() }} redeemed with stamps
            </span>
          </v-col>
        </v-row>

        <v-row class="stamp-redemption-summary-row no-gutters" style="display: flex; justify-content: space-between; margin-top: 10px">
          <v-col cols="6">
            <span class="summary-label">Stamp Redemption </span>
          </v-col>
          <v-col cols="6" class="text-right">
            <span class="summary-value">
              -{{ (currentPunchCardData.redeemCount || 0) * (punchCard.qty || 0) }} Stamps
            </span>
          </v-col>
        </v-row>
      </template>

      <template v-else-if="currentPunchCardData.earned && (currentPunchCardData.earned >= currentPunchCardData.redeemCount) || currentPunchCardData.using > 0">
        <v-row class="stamps-redemption-row align-center no-gutters">
            <v-col cols="6" class="text-left">
            <span class="redeemable-items">
                {{ currentPunchCardData.earned || 0}} stamps
            </span>
            </v-col>
            <v-col cols="6" class="text-right">
            <span class="redeemable-items">
                You can redeem for {{ allowedCards(currentPunchCardData) || 0 }} free {{ (currentPunchCardData.unitPluralString || currentPunchCardData.unitString || 'items').toLowerCase() }}
            </span>
            </v-col>
        </v-row>

        <v-row class="quantity-selector-row align-center no-gutters">
            <template v-if="currentQuantity === 0">
                <v-col cols="auto">
                <v-btn
                    color="orange"
                    class="redeem-btn"
                    @click="onChange(1, currentPunchCardData)"
                    depressed
                    small
                >
                    Redeem
                </v-btn>
                </v-col>
            </template>
            <template v-else>
            <v-row class="align-center no-gutters" style="display:flex; margin-top: 5px;">
                <v-col cols="auto" class="flex-grow-0 pr-0">
                <attribute-quantity-selector
                    :maximum-selected="allowedCards(currentPunchCardData) || 0"
                    :init-quantity="currentQuantity"
                    :min-cardinality="0"
                    :max-cardinality="allowedCards(currentPunchCardData) || 0"
                    @change="onChange($event, currentPunchCardData)"
                    class="custom-quantity-selector"
                />
                </v-col>
                <v-col class="pl-2 d-flex align-center">
                    <span class="redeemed-item-text" v-if="allowedCards(currentPunchCardData) > 0">
                    {{ currentQuantity === 1
                        ? (currentPunchCardData.unitString || 'item').toLowerCase()
                        : (currentPunchCardData.unitPluralString || currentPunchCardData.unitString || 'items').toLowerCase()
                    }}
                    </span>
                </v-col>
            </v-row>
            </template>
        </v-row>
        <v-row v-if="currentQuantity > 0" class="stamp-redemption-summary-row no-gutters" style="display: flex; justify-content: space-between; margin-top: 5px">
          <v-col cols="6">
            <span class="summary-label">Stamp Redemption: </span>
          </v-col>
          <v-col cols="6" class="text-right">
            <span class="summary-value">
              -{{ (currentPunchCardData.redeemCount || 0) * (currentPunchCardData.using || 0) }} Stamps
            </span>
          </v-col>
        </v-row>
      </template>
      <v-row v-if="!history" class="stamp-redemption-summary-row no-gutters" style="display: flex; justify-content: space-between;">
        <span class="offer-expiry">
          <template v-if="currentPunchCardData.validTo">
            {{ $vuetify.t('$vuetify.common.expires') }}: {{ formatExpirationDate(currentPunchCardData.validTo) }}
          </template>
          <template v-else>
            {{ $vuetify.t('$vuetify.account.rewards.noExpiration') }}
          </template>
        </span>
      </v-row>
    </template>
  </card-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import get from 'lodash/get';
import moment from 'moment';
import _ from 'lodash';

import { matchTranslation } from "@/services/util.service";
import AttributeQuantitySelector from "../AttributeQuantitySelector";
import CardWrapper from "@/components/Wrappers/CardWrapper";

export default {
  components: {
    AttributeQuantitySelector,
    CardWrapper
  },

  props: {
    punchCard: {
      type: Object,
      required: true
    },
    isFromHome: {
      type: Boolean,
      default: false
    },
    history: {
      type: Boolean,
      default: false
    },
    immutable: {
      type: Boolean,
      default: false
    },
    information: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '350px'
    }
  },
  data() {
    return {
        showAllDetails: false,
        showMoreDetailsLink: true,
        resizeObserver: null,
    }
  },
  computed: {
    currentPunchCardData() {
      if (this.history) {
        if (this.getPunchCards && this.getPunchCards.length > 0) {
          return this.getPunchCards.find(
            (card) => card.definitionCode === this.punchCard.code
          ) || {};
        }
        return {};
      }
      return this.punchCard;
    },

    descriptionRows() {
        const targetCard = this.currentPunchCardData;
        if (!targetCard || (!targetCard.name && !targetCard.code)) {
            return [];
        }

        const rows = [
            `Redeem ${targetCard.redeemCount || 0} stamps for a free ${(targetCard.unitString || targetCard.unitPluralString || 'item').toLowerCase()}`,
        ];
        // if (this.translatedDescription(targetCard)) {
        //     rows.push(this.translatedDescription(targetCard));
        // }
        return rows;
    },
    currentStoreId() {
      return get(this.getStore, 'storeId', null)
    },
    currentQuantity() {
        return this.currentPunchCardData.using || 0;
    },
    hasTargets() {
      return this.currentPunchCardData && this.currentPunchCardData.targets && this.currentPunchCardData.targets.length > 0;
    },

    ...mapGetters([
      'getStore',
      'getCustomerRewards',
      'getPunchCards',
      'getServerPunchCards',
      'getExistingOrder'
    ])
  },
  mounted() {
    this.$root.$refs.punchCard = this;
    console.log(this.punchCard)
  },
  beforeDestroy() {
    // Disconnect ResizeObserver when component is destroyed
    if (this.resizeObserver && this.$refs.descriptionList) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    formatExpirationDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    translatedName(punchCardObj) {
      return matchTranslation(get(punchCardObj, 'nameTranslation.translations', [])) || get(punchCardObj, 'name', '');
    },
    translatedDescription(punchCardObj) {
      return matchTranslation(get(punchCardObj, 'descriptionTranslation.translations', [])) || get(punchCardObj, 'description', '');
    },

    onChange(AmountSelected, punchCard) {
      this.$set(punchCard, 'storeId', this.currentStoreId);
      this.$set(punchCard, 'using', AmountSelected);
      this.$emit('update-redemption', { punchCard, amount: AmountSelected });
      this.fetchShoppingCart();
    },

    allowedPoints(punchCard) {
      let previousRewardsSum = 0;
      if (this.getExistingOrder && this.getExistingOrder.length) {
        previousRewardsSum = this.getExistingOrder.reduce((accumulator, order) => {
          if (order.punchCards && order.punchCards.length) {
            return (accumulator || 0) + order.punchCards.reduce((subSum, reward) => {
              if (reward.definitionCode === punchCard.definitionCode) {
                return subSum + (reward.qty * punchCard.redeemCount);
              }
              return subSum;
            }, 0);
          }
          return accumulator;
        }, 0);
      }
      return (punchCard.earned || 0) - previousRewardsSum;
    },

    allowedCards(punchCard) {
      if (!this.allowedPoints(punchCard) || !punchCard.redeemCount) {
        return 0;
      }
      return Math.floor(this.allowedPoints(punchCard) / punchCard.redeemCount);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      return moment(dateString).format("YYYY.MM.DD");
    },

    getImage(punchCard) {
      if (punchCard.imageURL)
        return `${process.env.VUE_APP_API_IMAGE}${punchCard.imageURL}`

      if ('REWARD' in this.getStore.images && this.getStore.images.REWARD[0] && this.getStore.images.REWARD[0].url)
        return `${process.env.VUE_APP_API_IMAGE}${this.getStore.images.REWARD[0].url}`

      return null
    },
    onImageError($error, punchCard) {
      console.error('Image Error', $error);
      punchCard.imageURL = null
    },

    openConfig() {
      const punchCard = this.currentPunchCardData;
      if (punchCard && Object.keys(punchCard).length > 0) {
        this.setCouponItemDialog(JSON.parse(JSON.stringify(punchCard)));
      }
    },

    ...mapActions(['fetchShoppingCart', 'fetchAccountDetails', 'setCouponItemDialog'])
  }
};
</script>

<style scoped>
.punchcard-detail-card >>> .textBody,
.punchcard-detail-card /deep/ .textBody {
  padding-left: 0 !important;
}
.punchcard-detail-card {
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  width: 100%;
}

.punchcard-detail-card:not(.history-card-padding) {
  max-width: 400px;
}

.history-layout {
  display: flex;
  justify-content: space-around;
  padding-top: 10px;
}

.pointsContainer {
  text-align: center;
}

.points {
  font-size: 18px;
  color: var(--v-primary-base);
}

.history-points {
    color: #F8BBD0 !important;
    font-weight: 600;
}

.history-layout .pointsContainer > div {
    font-size: 14px;
    color: #757575;
}

.static-quantity-display {
  font-size: 18px;
  font-weight: 600;
  color: #212121;
  margin: 0 10px;
  min-width: 30px;
  text-align: center;
  border: 2px solid #E0E0E0;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}


.punchcard-detail-content {
  padding: 16px;
}
.detail-header {
  font-size: 18px;
  font-weight: 600;
  color: var(--v-primary-base);
  width: 100%;
}

.history-card-padding .detail-header {
  font-size: 16px;
}

.close-button {
  color: #9E9E9E;
  background-color: #E0E0E0;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  min-width: unset;
  padding: 0;
}

.close-btn {
  justify-content: end !important;
  color: #9E9E9E !important;
}

.reward-description-list {
  list-style-type: disc;
  color: #757575;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 8px;
  padding-left: 0 !important;
}

.reward-description-list li {
  margin-bottom: 4px;
  word-break: break-word;
  overflow: visible;
}

.history-card-padding .reward-description-list li {
  font-size: 14px;
}

/* .history-card-padding {
  padding-right: 10px !important;
} */

.history-card-padding .textBody {
  padding-left: 22px !important;
  padding-right: 22px !important;
}

.history-card-padding .description {
  padding-left: 22px !important;
  padding-right: 22px !important;
}

.redeem-btn {
  background: var(--v-primary-base) !important;
  color: white !important;
  font-weight: 600;
}

.more-detail-link {
  color: var(--v-primary-base);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 4px;
}

.stamps-redemption-row {
  font-size: 12px;
  font-weight: 500;
  display:flex;
  justify-content: space-between;
  margin-top: 10px;
}

.current-stamps {
  color: var(--v-primary-base);
}

.redeemable-items {
  color: var(--v-primary-base);
  font-weight: 600;
}

.quantity-selector-row {
  margin-top: 16px;
  align-items: center;
}

.description-collapsed {
  content: "•";
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: list-item;
  list-style-type: disc;
  margin-left: 20px;
}

.description-collapsed-ellipsis {
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  width: 100%;
  list-style: none;
  position: relative;
  padding-left: 1.425em;
}

.description-collapsed-ellipsis::before {
  content: "•";
  position: absolute;
  color: #757575;
  font-size: 21px;
  left: 6.5px;
  top: -4px;
}


.description-expanded {
  white-space: normal;
  list-style: none;
  position: relative;
  padding-left: 1.425em;
}

.description-expanded::before {
  content: "•";
  position: absolute;
  color: #757575;
  font-size: 21px;
  left: 6.5px;
  top: -4px;
}

.custom-quantity-selector >>> .v-btn {
  min-width: 36px;
  height: 36px;
  border-radius: 50%;
  background: white 0 !important;
  border: 2px solid var(--v-primary-base) !important;
  color: var(--v-primary-base) !important;
  padding: 0;
  box-shadow: none !important;
}

.custom-quantity-selector >>> .v-btn.v-btn--disabled {
  background-color: #f5f5f5 !important;
  color: #bdbdbd !important;
  opacity: 1;
  border: 2px solid #e0e0e0 !important;
}

.custom-quantity-selector >>> .quantity-display {
  font-size: 18px;
  font-weight: 600;
  color: #212121;
  margin: 0 10px;
  min-width: 30px;
  text-align: center;
}

.redeemed-item-text {
  font-size: 16px;
  color: #212121;
  font-weight: bold;
}

.v-divider {
  border-color: #EEEEEE !important;
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.stamp-redemption-summary-row {
  font-weight: 500;
  color: var(--v-primary-base) !important;
}

.offer-expiry-row {
  margin-top: 16px;
}

.text-right {
    text-align: right;
}

.offer-expiry {
  font-size: 14px;
  color: #757575;
}
.reward-description-list {
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}

.description-row {
  flex-wrap: wrap !important;
}
</style>